import React from 'react'

import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api'

import { Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

export const DealerMap = ({ data }) => {
  const location = data.address?.location && {
    lat: +data.address?.location?.lat,
    lng: +data.address?.location?.lng
  }
  return (
    <Box height={200}>
      <LoadScript
        libraries={['places']}
        language="en"
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
        loadingElement={<Skeleton width="100%" height={200} />}
      >
        <GoogleMap
          mapContainerStyle={{ width: '100%', height: 200 }}
          center={location}
          zoom={10}
        >
          <Marker
            position={location}
            // icon={MarkerSvg}
          />
        </GoogleMap>
      </LoadScript>
    </Box>
  )
}
